import { makeStyles } from '@material-ui/core';
import { FlashOn as FlashOnIcon } from '@material-ui/icons';

import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
    icon: {
        color: '#ffeb3b',
    },
    childCount: {
        position: 'absolute',
        top: '100%',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '1rem',
        textShadow: '0 -1px #FFFFFF, 1px 0 #FFFFFF, 0 1px #FFFFFF, -1px 0 #FFFFFF',
    },
});

const LightningsIcon = ({ childCount }) => {
    const classes = useStyles();

    return (
        <>
            <FlashOnIcon classes={{ root: classes.icon }} fontSize="large" stroke="gray" />
            <span className={classes.childCount}>{`(${childCount})`}</span>
        </>
    );
};

LightningsIcon.propTypes = {
    childCount: PropTypes.number,
};

export default LightningsIcon;
